import Header from '../../components/Header'
import './About.css'
import HeaderImg from '../../images/about_us-img.JPG'
import StoryImage from '../../images/story-img.png'
import visionImage from '../../images/vision-img.JPG'
import missionImage from '../../images/mission-img.jpg'
import { aboutStory } from '../../data'

const sectionImages = [StoryImage, visionImage, missionImage]
const sectionKeys = ['story', 'vision', 'mission']

const About = () => {
  return (
    <>
      <Header title="About Us" image={HeaderImg}>
        Whatever your level, start where you are and we'll shepherd you to where you want to be.
      </Header>

      {aboutStory.map((section, index) => {
        const imageLeft = index % 2 === 0
        const image = sectionImages[index]
        const key = sectionKeys[index]

        return (
          <section key={section.id} className={`about__${key}`}>
            <div className={`container about__${key}-container`}>
              {imageLeft && (
                <div className='about__section-image'>
                  <img src={image} alt={section.title} />
                </div>
              )}
              <div className='about__section-content'>
                <h1>{section.title && <h1>{section.title}</h1>}</h1>
                {section.paragraphs.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
              {!imageLeft && (
                <div className='about__section-image'>
                  <img src={image} alt={section.title} />
                </div>
              )}
            </div>
          </section>
        )
      })}
    </>
  )
}

export default About